import React, { type PropsWithChildren } from 'react';
import { SearchDialog } from '@atlassian/search-dialog';
import { useDialogExpansionContext } from '../../dialog-expansion-context/dialog-expansion-context';
import { useFeaturesContext } from '../../features-context/features-context';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlaskit/platform-feature-flags';

export const ProductSearchDialogWrapper: ({
	children,
	shouldFillContainer,
}: PropsWithChildren<{
	shouldFillContainer?: boolean;
}>) => React.JSX.Element = ({
	children,
	shouldFillContainer,
}: PropsWithChildren<{ shouldFillContainer?: boolean }>) => {
	const { isExpanded } = useDialogExpansionContext();
	const { quickFind } = useFeaturesContext();

	return (
		<SearchDialog
			shouldFillContainer={shouldFillContainer}
			isExpanded={isExpanded}
			style={{
				boxShadow: isExpanded ? undefined : 'none',
				borderRadius: quickFind?.enabled 
					? fg('confluence_frontend_tokenize_border') 
						? token('radius.medium')  // 6px - proper radius token without fallback
						: token('space.100', '8px')  // Legacy fallback
					: undefined,
			}}
		>
			{children}
		</SearchDialog>
	);
};
